export interface IPin {
  pin: string
  comparePin: string
}

export class UserPin {
  pin = ''
  comparePin = ''

  constructor(init?: IPin) {
    Object.assign(this, init)
  }
}

export interface IPinDTO {
  pin: string
  emailAddress: string
}
